import { useState, useEffect } from 'react'
import * as React from 'react'
import {
  Toolbar,
  SaveButton,
  SimpleForm,
  TextInput,
  NumberInput,
  Datagrid,
  Edit,
  TextField,
  ReferenceInput,
  SelectInput,
  Show,
  SimpleShowLayout,
  Button,
  useRefresh,
  FormDataConsumer,
  useDataProvider,
  useNotify,
  ArrayField,
  BooleanField,
  BooleanInput,
  RadioButtonGroupInput,
  DateTimeInput,
  useTranslate,
  useRecordContext,
  useDelete,
  required,
  FunctionField,
} from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import {
  CustomToolbar,
  EmptyShowActions,
  DisplayVPCLink,
  ImageFieldCustom,
} from '../utils'
import {
  Button as ButtonM,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from '@material-ui/core'
import { Divider, Tabs, Tab, Link } from '@material-ui/core'
import { VoteWrapper } from './extranet_ags'
import AgsFormTimeSheet from '../intranet/AGS/AgsSign/'
import { useNavigate } from 'react-router'
import imageIllustration3 from '../assets/images/illustration3.svg'
import Box from '@mui/material/Box'
import PreviewFile from '../common/PreviewFile/PreviewFile'
import ApiAGS from '../intranet/AGS/api/apiAgs'

const CustomField = () => {
  const record = useRecordContext()
  record.external = window.location.origin + '/ext_ags2/' + record.code

  return (
    <Typography>
      <a href={record.external} target="_blank" rel="noreferrer">
        Accéder à l'espace unique copropriétaires
      </a>
    </Typography>
  )
}

const ImageFieldWrapper = (props) => {
  const record = useRecordContext()

  return (
    <ImageFieldCustom
      record={record}
      source={props.source}
      label={props.label}
    />
  )
}

const ContractButton = (props) => {
  const record = useRecordContext()
  if (record.contract.length === 0) {
    return null
  } else {
    return <ImageFieldWrapper label="Contrat" source="contract" {...props} />
  }
}

//record = a registration
const DeleteButton = (props) => {
  const record = useRecordContext()
  const refresh = useRefresh()
  const notify = useNotify()
  const dataProvider = useDataProvider()
  const func = () =>
    dataProvider
      .delete('agregistrations', { id: record.id })
      .then(() => {
        notify('Succès')
        refresh()
      })
      .catch((error) => {
        notify(`${error.message}`, 'warning')
      })
  return (
    <Button
      label="Effacer enregistrement et votes associés"
      onClick={func}
      disabled={props.disabled}
    />
  )
}
//record = a registration
const ValidateButton = () => {
  const record = useRecordContext()
  const refresh = useRefresh()
  const notify = useNotify()
  const dataProvider = useDataProvider()
  var disabled = false
  if (record.validated === true) {
    disabled = true
  }
  var new_record = JSON.parse(JSON.stringify(record))
  //we send only id and validated flag, to speed up upload (avoid re-sending base64 string etc)
  var light_record = {
    id: new_record.id,
    validated: true,
  }
  const func = () =>
    dataProvider
      .update('agregistrations', { id: light_record.id, data: light_record })
      .then((response) => {
        notify('Succès')
        refresh()
      })
      .catch((error) => {
        notify(`${error.message}`, 'warning')
      })
  return (
    <Button label="Valider Enregistrement" onClick={func} disabled={disabled} />
  )
}

//record = a vote
const DeleteVote = (props) => {
  const record = useRecordContext()
  const refresh = useRefresh()
  const notify = useNotify()
  if (record.id === null) {
    return null
  }

  const [deleteOne, { isLoading }] = useDelete(
    'votes',
    { id: record.id },
    {
      onSuccess: (data) => {
        refresh()
        props.onSuccess(record.id)
        notify('Succès')
      },
      onError: (error) => {
        notify(`Erreur: ${error.message}`, { type: 'warning' })
      },
    }
  )
  return (
    <Button label="Effacer" onClick={() => deleteOne()} disabled={isLoading} />
  )
}

const RecordWithSubResolutionData = ({ sub_resolution_data, ...data }) => {
  if (sub_resolution_data) {
    return {
      ...data,
      ...sub_resolution_data,
      libelle:
        data.libelle.indexOf('SUB-') === -1
          ? `SUB-${data.libelle}`
          : data.libelle,
    }
  }

  return { ...data }
}

const ContractToolbar = ({
  ag_id,
  save,
  record: ParentRecord,
  disabled,
  ...props
}) => {
  const record = ParentRecord || useRecordContext()
  const [isSending, setIsSending] = useState(false)
  const translate = useTranslate()

  return (
    <Toolbar {...props}>
      <Grid container spacing={2}>
        <Grid item>
          <FormDataConsumer>
            {({ formData }) => (
              <Box>
                <SaveButton
                  disabled={isSending || disabled}
                  label={props.label || 'Envoyer'}
                  onClick={() => {
                    setIsSending(true)
                    save({ record, formData, setIsSending })
                  }}
                />
              </Box>
            )}
          </FormDataConsumer>
        </Grid>
      </Grid>
    </Toolbar>
  )
}

const optionRenderer = (choice) => (
  <span data-email={choice.email}>{`${choice.name} - ${choice.email}`}</span>
)

const Resend = (props) => {
  const dataProvider = useDataProvider()
  const notify = useNotify()

  const signrequest_id = props.signrequest_id

  const resendSignRequestEmails = () => {
    dataProvider
      .update('signrequests', { id: signrequest_id, data: { resend: true } })
      .then((response) => {
        alert('Relance effectuée')
      })
      .catch((error) => {
        console.log(error.message)
        alert(error.message)
        notify(error.message, 'warning')
      })
  }

  return (
    <ButtonM
      color="secondary"
      variant="contained"
      onClick={resendSignRequestEmails}
    >
      Relancer les signataires
    </ButtonM>
  )
}

const Getstatus = ({ signrequest_id, type }) => {
  const dataProvider = useDataProvider()
  const notify = useNotify()
  const [signers, setSigners] = useState([])
  const [doc, setDoc] = useState()
  const translate = useTranslate()
  const refresh = useRefresh()

  useEffect(() => {
    if (type === 'contract') {
      getSignRequest()
    }
  }, [type])

  const getSignRequest = () => {
    dataProvider
      .getOne('signrequests', { id: signrequest_id })
      .then(({ data }) => {
        const { data1, data2 } = data
        setSigners(data1.signers.filter((s) => s.email !== 'copro@manda.fr'))
        setDoc({
          name: data2.name,
          url: data2.pdf || data2.file_as_pdf || data2.file,
        })
      })
      .catch((error) => {
        console.log(error.message)
        alert(error.message)
        notify(error.message, 'warning')
      })
  }

  const handleCancelContract = () => {
    dataProvider
      .delete('signrequests', {
        id: signrequest_id,
      })
      .then(() => {
        refresh()
        notify('Envoi de contrat annulé')
      })
      .catch((error) => {
        notify(error.message, 'warning')
      })
  }

  return (
    <div>
      <ButtonM color="secondary" variant="contained" onClick={getSignRequest}>
        RAFRAICHIR LE STATUT DE SIGNATURE ET LE DOCUMENT
      </ButtonM>
      <br />
      {signers.length > 0 ? (
        <div>
          <br />
          {signers.map((s) => {
            return (
              <div key={s.email}>
                Email: {s.email}
                <br />
                Vu: {s.viewed ? 'Oui' : 'Non'}
                <br />
                Signé: {s.signed ? 'Oui' : 'Non'}
                <br />
              </div>
            )
          })}
          <br />
          {doc && doc.url ? (
            <ButtonM
              color="secondary"
              variant="contained"
              download={doc.name}
              href={doc.url}
              // If the document url allow it we download it directly otherwise we open it in a new tab.
              target="_blank"
            >
              {translate('hs.ags.link_to_document')}
            </ButtonM>
          ) : (
            <Typography>
              {translate('hs.errors.missing_link_to_document')}
            </Typography>
          )}
        </div>
      ) : (
        <div />
      )}
      <br />
      {signers.every((s) => !s.signed) && (
        <ButtonM
          color="secondary"
          variant="contained"
          onClick={handleCancelContract}
        >
          ANNULER L'ENVOI DU CONTRAT
        </ButtonM>
      )}
    </div>
  )
}

const SendUnsignedCopromatic = (props) => {
  const dataProvider = useDataProvider()
  const notify = useNotify()

  const signrequest_id = props.signrequest_id

  const sendUnsignedCopromatic = () => {
    dataProvider
      .update('signrequests', {
        id: signrequest_id,
        data: { upload_unsigned: true },
      })
      .then((response) => {
        console.log(response.data)
        notify('PV uploadé')
        alert('PV uploadé')
      })
      .catch((error) => {
        console.log(error.message)
        alert(error.message)
        notify(error.message, 'warning')
      })
  }

  return (
    <ButtonM
      color="secondary"
      variant="contained"
      onClick={sendUnsignedCopromatic}
    >
      Uploader le PV non signé (CPMTC)
    </ButtonM>
  )
}

const CancelSignRequest = ({ signrequest_id }) => {
  const dataProvider = useDataProvider()
  const notify = useNotify()
  const translate = useTranslate()
  const refresh = useRefresh()
  const [openConfirmation, setOpenConfirmation] = useState(false)
  const cancelSignRequestHandler = () => {
    dataProvider
      .delete('signrequests', {
        id: signrequest_id,
      })
      .then(() => {
        refresh()
        notify(translate('hs.ags.success.cancel_signrequest'))
      })
      .catch((error) => {
        notify(error.message, 'warning')
      })
  }

  return (
    <>
      <ButtonM
        color="secondary"
        variant="contained"
        onClick={() => {
          setOpenConfirmation(true)
        }}
      >
        {translate('hs.ags.cancel_signrequest')}
      </ButtonM>
      <CancelRequestConfirmation
        onClose={() => {
          setOpenConfirmation(false)
        }}
        onClick={cancelSignRequestHandler}
        open={openConfirmation}
      />
    </>
  )
}
const CancelRequestConfirmation = ({ open, onClose, onClick }) => {
  const translate = useTranslate()

  return (
    <Dialog open={open} onClose={onClose} maxWidth={'sm'} fullWidth>
      <DialogTitle>
        <Typography style={{ fontWeight: 700 }}>
          Confirmation d'annulation de PV
        </Typography>
      </DialogTitle>
      <DialogContent style={{ marginTop: 10, marginBottom: 10 }}>
        <Typography>Êtes-vous sûr de vouloir annuler le PV ?</Typography>
      </DialogContent>
      <DialogActions>
        <ButtonM variant="contained" onClick={onClose}>
          Fermer
        </ButtonM>
        <ButtonM color="secondary" variant="contained" onClick={onClick}>
          {translate('hs.ags.cancel_signrequest')}
        </ButtonM>
      </DialogActions>
    </Dialog>
  )
}

const SendPvAg = (props) => {
  const record = useRecordContext()
  const ag_id = record.id

  //ag id, which we use in the back to filter list of coproprietaires
  window.context['context-token'] = record.code
  //to get coproprietaires, we will use /ext_coproprietaires
  //---> we use the same mechanism that coproprietaires select on vote register form

  const dataProvider = useDataProvider()
  const notify = useNotify()
  const translate = useTranslate()
  const [defaultPresidentPVEmail, setDefaultPresidentPVEmail] = useState()
  const [defaultSecretaryPVEmail, setDefaultSecretaryPVEmail] = useState()
  const [defaultScrutineerPVEmail, setDefaultScrutineerPVEmail] = useState()

  const [file, setFile] = useState('')
  const [openPreview, setOpenPreview] = useState(false)
  const [loadingFile, setLoadingFile] = useState(false)
  const apiAgs = new ApiAGS()
  const getPvPreview = async () => {
    setLoadingFile(true)
    const res = await apiAgs.preview(ag_id)
    if (res?.status == 200) {
      setFile(res.data.content)
      setOpenPreview(true)
    }
    setLoadingFile(false)
  }
  const sendPv = ({ record, formData, setIsSending }) => {
    const { id: ag_id, ...rest } = record
    dataProvider
      .create('signrequests', {
        data: { type: 'pv', generate: true, ag_id, ...rest, ...formData },
      })
      .then((response) => {
        sendDataToCopromatic(ag_id)
          .then(async (response) => {
            let body = await response.json()

            if (300 <= response.status) {
              if (body && body.message)
                body.message.forEach((message) => {
                  notify(
                    translate('hs.copromatic.ag.errors.send', { message }),
                    'error'
                  )
                })
              else
                notify(
                  translate('hs.copromatic.ag.errors.send', {
                    message: "Erreur d'envoi",
                  }),
                  'error'
                )
            } else notify(translate('hs.ags.success.pv_sended', 'success'))
          })
          .catch((e) => {
            console.log(e)
            notify(
              translate('hs.copromatic.ag.errors.send', { message: e.message }),
              'error'
            )
          })
          .finally(() => {
            setIsSending(false)
          })
      })
      .catch((error) => {
        console.log('ERROR', error)
        notify(error.message, 'warning')
        setIsSending(false)
      })
  }

  if (
    record.pv_signrequest_request_id !== null &&
    record.pv_signrequest_request_id !== undefined
  ) {
    return (
      <div>
        <br />
        <br />
        <Typography variant="subtitle">
          Le PV a été envoyé pour signature électronique. Id de la request:{' '}
          {record.pv_signrequest_request_id}
        </Typography>
        <br />
        <br />
        <Grid container spacing={2} px={3}>
          {record.pv_copromatic_url === null ? (
            <Grid item>
              <SendUnsignedCopromatic
                signrequest_id={record.pv_signrequest_request_id}
              />
            </Grid>
          ) : (
            <Grid xs={12} item>
              <Typography variant="subtitle">
                Le PV non signé a été envoyé à CPMTC: <br />
                <Link
                  href={record.pv_copromatic_url}
                  target="_blank"
                  color="inherit"
                >
                  {record.pv_copromatic_url}
                </Link>
              </Typography>
            </Grid>
          )}
          <Grid item>
            <Resend signrequest_id={record.pv_signrequest_request_id} />
          </Grid>
          <Grid item>
            <CancelSignRequest
              signrequest_id={record.pv_signrequest_request_id}
            />
          </Grid>
          <Grid item>
            <Getstatus
              signrequest_id={record.pv_signrequest_request_id}
              type="pv"
            />
          </Grid>
          <Grid item>
            <Grid item>
              <ButtonM
                color="secondary"
                variant="contained"
                onClick={getPvPreview}
                disabled={loadingFile}
              >
                {loadingFile ? 'Chargement...' : 'Consulter le PV'}
              </ButtonM>
            </Grid>
          </Grid>
          <Grid item>
            <ButtonM
              color="secondary"
              variant="contained"
              target="_blank"
              href={`${window.location.origin}/pvagsfeuillepresence/${ag_id}/show`}
            >
              {translate('hs.ags.attendance_sheet')}
            </ButtonM>
          </Grid>
        </Grid>
        <br />
        <br />
        <PreviewFile
          base64={file}
          open={openPreview}
          onClose={() => {
            setOpenPreview(!openPreview)
            setFile('')
          }}
        />
      </div>
    )
  }

  return (
    <>
      <AgsFormTimeSheet
        agId={ag_id}
        setDefaultPresidentPVEmail={setDefaultPresidentPVEmail}
        setDefaultSecretaryPVEmail={setDefaultSecretaryPVEmail}
        defaultPresidentPVEmail={defaultPresidentPVEmail}
        defaultSecretaryPVEmail={defaultSecretaryPVEmail}
        imageIllustration3={imageIllustration3}
        optionRenderer={optionRenderer}
        sendPv={sendPv}
        loadingFile={loadingFile}
        getPvPreview={getPvPreview}
      />
      <PreviewFile
        base64={file}
        open={openPreview}
        onClose={() => {
          setOpenPreview(!openPreview)
          setFile('')
        }}
      />
    </>
  )
}

const SendContractAg = () => {
  const record = useRecordContext()
  const dataProvider = useDataProvider()
  const {
    contract_signrequest_request_id,
    id,
    copro_id_nomonday, // @todo: normalize the name if is our internal id name it like that.
    code,
  } = record

  //ag id, which we use in the back to filter list of coproprietaires
  window.context['context-token'] = code
  //to get coproprietaires, we will use /ext_coproprietaires
  //---> we use the same mechanism that coproprietaires select on vote register form

  const notify = useNotify()
  const refresh = useRefresh()
  const [contractSelected, setContractSelected] = useState()
  const [presidentSelected, setPresidentSelected] = useState()

  const sendContract = async ({ record, formData, setIsSending }) => {
    const { id: ag_id, copro_id_nomonday, disabled_contract, ...rest } = record
    setIsSending(true)

    try {
      if (formData.disabled_contract !== disabled_contract) {
        await backofficeRequest.put(
          `backoffice/condominiums/${copro_id_nomonday}/general-assemblies/copromatic-id/${ag_id}`,
          { disabledContract: formData.disabled_contract }
        )
        notify(`Enregistrement effectué`, { type: 'success' })
      }

      if (!formData.disabled_contract) {
        await dataProvider.create('signrequests', {
          data: { type: 'contract', ag_id, ...rest, ...formData },
        })
        notify('Le contrat est envoyé.', { type: 'success' })
      }

      refresh()
    } catch (error) {
      notify(error.message, { type: 'warning' })
    } finally {
      setIsSending(false)
    }
  }

  if (contract_signrequest_request_id) {
    return (
      <div>
        <br />
        <br />
        <Typography variant="subtitle">
          Le Contrat a été envoyé pour signature électronique via SignRequest.
          Id de la request: {contract_signrequest_request_id}
        </Typography>
        <br />
        <br />
        <Resend signrequest_id={contract_signrequest_request_id} />
        <br />
        <br />
        <Getstatus
          signrequest_id={contract_signrequest_request_id}
          type="contract"
        />
      </div>
    )
  }
  return (
    <SimpleForm
      toolbar={
        <FormDataConsumer>
          {({ formData }) => (
            <ContractToolbar
              save={sendContract}
              disabled={
                !formData.disabled_contract &&
                (!contractSelected || !presidentSelected)
              }
              label={formData.disabled_contract ? 'Enregistrer' : 'Envoyer'}
            />
          )}
        </FormDataConsumer>
      }
      defaultValues={{ ag_id: id }}
      redirect={false}
      resource="signrequests"
      basePath="/"
      variant="outlined"
    >
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          const { setValue } = useFormContext()
          return (
            <>
              <BooleanInput
                source="disabled_contract"
                label="Pas de contrat"
                onChange={(e) =>
                  setValue('disabled_contract', e.target.checked)
                }
              />
              {!formData.disabled_contract && (
                <>
                  <ReferenceInput
                    label="Président"
                    source="president_id"
                    reference="ext_coproprietaires"
                    style={{
                      display: 'inline-block',
                      float: 'left',
                      marginRight: '8px',
                    }}
                  >
                    <SelectInput
                      optionText={optionRenderer}
                      allowEmpty
                      fullWidth
                      onChange={(e) => {
                        if (e.target.value) {
                          setPresidentSelected(true)
                        }
                        setValue(
                          'president_email',
                          document
                            .querySelector(
                              'ul[aria-labelledby="president_id-label"]'
                            )
                            .querySelector(`li[data-value="${e.target.value}"]`)
                            .querySelector('span')
                            .getAttribute('data-email')
                        )
                        // We have to get the nested property value given to React admin restrictions.
                      }}
                    />
                  </ReferenceInput>
                  <TextInput
                    variant="outlined"
                    label="Président (email libre)"
                    source="president_email"
                    style={{
                      display: 'inline-block',
                      float: 'left',
                      marginRight: '8px',
                    }}
                  />
                  <ReferenceInput
                    label="Contrat"
                    source="contract_id"
                    reference="contracts"
                    filter={{
                      copro_id_nomonday: copro_id_nomonday,
                      type: 'Syndic',
                    }}
                  >
                    <SelectInput
                      optionText="url"
                      allowEmpty
                      onChange={(value) => {
                        if (value) {
                          setContractSelected(true)
                        }
                      }}
                      validate={required()}
                    />
                  </ReferenceInput>
                </>
              )}
            </>
          )
        }}
      </FormDataConsumer>
    </SimpleForm>
  )
}

const MvToolbar = (props) => {
  return (
    <Toolbar {...props}>
      <SaveButton label="Faire voter" {...props} />
    </Toolbar>
  )
}

const SendMultiVotesRefactored = (props) => {
  const [disabled, setDisabled] = useState(false)
  const ag = useRecordContext(props)
  const resolution = props.resolution

  const dataProvider = useDataProvider()
  const notify = useNotify()

  //We have to filter on .id not null cuze resolution.votes contains all ag registrations even the ones that did not vote yet (by design)

  // const votes = ag.resolutions.filter((r) => r.id === resolution.id)[0]['votes'].filter((v) => v.id !== null)

  // WARNING the next 2 lines destrcture the previous function without testing it
  const matchingResolution = ag.resolutions.find((r) => r.id === resolution.id)
  const votes = matchingResolution['votes'].filter((v) => v.id !== null)

  const unvoted_registrations = ag.ag_registrations.filter((agr) => {
    return votes.filter((v) => v.agr_id == agr.id).length == 0
  })

  const sendVotes = (votes) => {
    setDisabled(true)
    dataProvider
      .create('resolutions', {
        data: votes,
      })
      .then(() => {
        notify(
          'Les votes sont faits. (Pour rafraichir le détail des votes, rafraichissez votre page)'
        )
        setDisabled(false)
      })
      .catch((error) => {
        setDisabled(false)
        console.log(error.message)
        notify(error.message, 'warning')
      })
  }

  return unvoted_registrations.length > 0 ? (
    <SimpleForm
      onSubmit={sendVotes}
      toolbar={<MvToolbar disabled={disabled} />}
      defaultValues={{
        ag_id: ag.id,
        resolution_id: resolution.id,
        ag_registrations: ag.ag_registrations,
        multivotes: true,
      }}
      redirect={false}
      resource="resolutions"
      basePath="/"
      variant="outlined"
      component="div"
    >
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          votes.map((v) => {
            var key = 'param_agr_' + v.agr_id
            formData[key] = v.vote
          })
        }}
      </FormDataConsumer>
      {unvoted_registrations.map((r) => {
        return (
          <RadioButtonGroupInput
            source={'param_agr_' + r.id}
            label={r.libelle}
            choices={[
              { id: 'Pour', name: 'Pour' },
              { id: 'Contre', name: 'Contre' },
              { id: 'Abstention', name: 'Abst.' },
            ]}
          />
        )
      })}
    </SimpleForm>
  ) : (
    <p>
      Tous les coproprietaires enregistrés ont votés. Aucune saisie nécessaire.
    </p>
  )
}

//NOTE: the button to delete a registration and all its votes is in a ReferenceManyField
//so it does not have access to the Ag record.
//So we use a state variable inside the AgEdit component, which is updated by this Hack component.
const Hack = ({ setOr, setR }) => {
  const record = useRecordContext()
  setOr(record.open_resolution_id)
  setR(record.not_ready)

  return null
}

const Title1 = () => <Typography variant="h6">Désignation de l'AG</Typography>
const Title2 = () => (
  <Typography variant="h6" gutterBottom>
    Configuration de la visio
  </Typography>
)
const Title2bis = () => (
  <Grid style={{ padding: '16px' }}>
    <Typography variant="h6">
      Saisie des votes par correspondance papier
    </Typography>
    <Typography variant="subtitle1" gutterBottom>
      Utilisez le formulaire ci-dessous pour saisir les votes du copropriétaire.
    </Typography>
  </Grid>
)

const SignPvAndAttendanceTitle = () => {
  const translate = useTranslate()

  return (
    <Typography variant="h6">
      {translate('hs.ags.sign_pv_and_attendance_title')}
    </Typography>
  )
}

const Title5 = () => (
  <Typography variant="h6">Liste des copropriétaires</Typography>
)
const Title7 = () => (
  <Typography variant="h6">Signature du Contrat syndic</Typography>
)

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  }
}

export default function VerticalTabs(props) {
  const id_var = props.id_var
  const [value, setValue] = React.useState(0)
  const [record, setRecord] = useState(props.record)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  const noVoteMessage = record.votes.length == 0 ? <p>Aucun vote</p> : null

  const onSuccess = (deletedId) => {
    window['vote_modal_id'] = id_var
    record.votes = record.votes.filter((v) => v.id != deletedId)
    setRecord(JSON.parse(JSON.stringify(record)))
  }

  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: 'background.paper',
        display: 'flex',
        height: 224,
      }}
    >
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: 'divider' }}
      >
        <Tab label="Détail des votes" {...a11yProps(0)} />
        <Tab label="Saisir les votes" {...a11yProps(1)} />
      </Tabs>
      <TabPanel value={value} index={0}>
        {noVoteMessage}
        <ArrayField source="votes" label="Votes" record={record}>
          <Datagrid bulkActionButtons={false}>
            <TextField label="Nom" source="libelle" />
            <TextField label="Vote" source="vote" />
            <TextField label="Source" source="origin" />
            <DeleteVote onSuccess={onSuccess} />
          </Datagrid>
        </ArrayField>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Edit resource="resolutions" id={props.record.id} redirect={false}>
          <SendMultiVotesRefactored record={props.ag} resolution={record} />
        </Edit>
      </TabPanel>
    </Box>
  )
}

//ShowButton does not work in ArrayField (worked in ReferenceManyField)
const ShowRegistration = (props) => {
  const record = useRecordContext()
  const path = '/agregistrations/' + record.id + '/show'

  const onClick = () => {
    window.open(window.location.origin + path, '_blank')
  }
  return <ButtonM onClick={onClick}>Afficher</ButtonM>
}

const TabsComponent = (props) => {
  const navigate = useNavigate()
  const record = useRecordContext()
  const tabs_items = [
    { id: 'Infos & configuration', name: 'Infos & configuration', route: '1a' },
    { id: 'Convocations', name: 'Convocations', route: '_convocations' },
    { id: 'VPC', name: 'VPC', route: '5' },
    {
      id: 'Enregistrements copropriétaires',
      name: 'Enregistrements copropriétaires',
      route: '2',
    },
    { id: 'Résolutions', name: 'Resolutions', route: '3' },
    {
      id: 'Signature PV & feuille de présence',
      name: 'Admin - PV',
      route: '4',
    },
  ]
  const [tab, setTab] = useState(tabs_items[props.idx].id)
  const handleChange = (event, value) => {
    var idx = tabs_items.findIndex((obj) => obj.id === value)
    var nb = tabs_items[idx]['route']
    navigate(`/ags${nb}/${id}`)
  }
  if (!record) return null
  const { id } = record

  return (
    <div>
      <Tabs
        variant="fullWidth"
        centered
        value={tab}
        indicatorColor="primary"
        onChange={handleChange}
      >
        {tabs_items.map((choice) => (
          <Tab key={choice.id} label={choice.name} value={choice.id} />
        ))}
      </Tabs>
      <Divider />
    </div>
  )
}

const RegisterPapier = (props) => {
  const ag = useRecordContext(props)
  const refresh = () => {}
  if (!ag) return null

  //Here we add some margin on Title component because it is not inside a SimpleForm so there is no margin
  return (
    <>
      <Title2bis style={{ margin: '15px' }} />
      <VoteWrapper
        refresh={refresh}
        ag={ag}
        vpc={true}
        coproprietaires={ag.coproprietaires}
      />
    </>
  )
}

export const FormIterator = () => {
  const record = useRecordContext()
  const refresh = useRefresh()
  return <ConfigVisio record={record} refresh={refresh} />
}

const SynchronizeCopromaticButton = () => {
  const record = useRecordContext()

  const importCopromaticAg = async (AGId, coproId) => {
    try {
      await backofficeRequest.get(
        `backoffice/condominiums/${coproId}/general-assemblies/${AGId}/force-copromatic-update`
      )
    } catch (error) {
      return error
    }
  }

  return (
    <ButtonM
      variant="contained"
      color="secondary"
      onClick={() =>
        importCopromaticAg(record.internal_id, record.copro_internal_id)
      }
    >
      Synchroniser avec Copromatic
    </ButtonM>
  )
}

export const AG1 = (props) => {
  const userType = localStorage.getItem('user_type')

  const displaySynchronizeButton =
    userType &&
    (userType.includes('Admin') || userType.includes('Gestionnaire'))

  return (
    <>
      <Show {...props} actions={<EmptyShowActions />}>
        <TabsComponent idx={0} {...props} />
      </Show>
      <Show {...props} actions={false}>
        <SimpleShowLayout sx={{ padding: '1rem' }}>
          <Title1 />
          <TextField label=" " source="ag_title" />
          <CustomField label="URL externe" />
          <TextField source="code" label="Code AG (pour se connecter)" />
          <br />
          {displaySynchronizeButton && <SynchronizeCopromaticButton />}
        </SimpleShowLayout>
      </Show>
      <Edit redirect={false}>
        <FormIterator />
      </Edit>
    </>
  )
}

const LegendSquare = ({ color, ...props }) => {
  return (
    <span
      style={{
        display: 'inline-block',
        width: '20px',
        height: '20px',
        borderRadius: '5px',
        borderWidth: '2px',
        backgroundColor: color,
        ...props,
      }}
    />
  )
}
const PresenceChart = () => {
  let record = useRecordContext()

  const { presents, presents_with_mandatory, absents, vpc } = record.tantiemes
  const { coowner_stats } = record

  const tantiemesTotal = presents + presents_with_mandatory + absents + vpc

  const coownersTotal =
    coowner_stats.presents +
    coowner_stats.presents_with_mandatory +
    coowner_stats.vpc +
    coowner_stats.absents

  const tantiemesVotants = presents + presents_with_mandatory + vpc
  const coownersVotants =
    coowner_stats.presents +
    coowner_stats.presents_with_mandatory +
    coowner_stats.vpc

  const tantiemesVotantsPercent =
    tantiemesTotal > 0 && tantiemesVotants > 0
      ? ((tantiemesVotants / tantiemesTotal) * 100).toFixed(2)
      : 0
  const coownersVotantsPercent =
    coownersTotal > 0 && coownersVotants > 0
      ? Math.round((coownersVotants / coownersTotal) * 100)
      : 0

  const options = {
    indexAxis: 'x',
    elements: {
      bar: {
        borderWidth: 2,
        borderRadius: 10,
        borderSkipped: false,
        categoryPercentage: 1.0,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      x: {
        ticks: {
          font: {
            weight: 'bold',
            family:
              '"Nunito Sans", -apple-system, Helvetica, Arial, sans-serif',
          },
        },
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
      },
      y: {
        ticks: {
          display: false,
        },
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
      },
    },
  }

  const data = {
    labels: [
      Math.round((presents / tantiemesTotal) * 100) + '%',
      Math.round((presents_with_mandatory / tantiemesTotal) * 100) + '%',
      Math.round((vpc / tantiemesTotal) * 100) + '%',
      Math.round((absents / tantiemesTotal) * 100) + '%',
    ],
    datasets: [
      {
        data: [presents, presents_with_mandatory, vpc, absents],
        borderColor: 'transparent',
        backgroundColor: [
          'rgb(255, 99, 132)',
          'rgb(255, 205, 86)',
          'rgb(75, 192, 192)',
          'rgb(54, 162, 235)',
        ],
        barThickness: 60,
        categoryPercentage: 1.0,
      },
    ],
  }
  return (
    <>
      <Grid container spacing={2} alignItems={'center'}>
        <Grid item xs={3}>
          <Bar data={data} options={options} />
        </Grid>
        <Grid item md={6} xs={8}>
          <Grid container spacing={2} alignItems={'center'}>
            <Grid
              item
              xs={'auto'}
              alignContent={'center'}
              direction={'column'}
              style={{ display: 'flex' }}
            >
              <LegendSquare color="rgb(255, 99, 132)" />
              <LegendSquare color="rgb(255, 205, 86)" margin={'12px 0'} />
              <LegendSquare color="rgb(75, 192, 192)" marginBottom={'12px'} />
              <LegendSquare color="rgb(54, 162, 235)" />
            </Grid>
            <Grid
              item
              xs={'auto'}
              alignContent={'center'}
              style={{ display: 'flex', marginRight: '12px' }}
              direction={'column'}
            >
              <span>{presents} tantièmes présents</span>
              <span style={{ margin: '12px 0' }}>
                {presents_with_mandatory} tantiemes représentés
              </span>
              <span style={{ marginBottom: '12px' }}>{vpc} tantièmes VPC</span>
              <span>{absents} tantièmes absents</span>
            </Grid>
            <Grid
              item
              xs={'auto'}
              alignContent={'center'}
              style={{ display: 'flex' }}
              direction={'column'}
            >
              <span>{coowner_stats.presents} copropriétaires présents</span>
              <span style={{ margin: '12px 0' }}>
                {coowner_stats.presents_with_mandatory} copropriétaires
                représentés
              </span>
              <span style={{ marginBottom: '12px' }}>
                {coowner_stats.vpc} copropriétaires VPC
              </span>
              <span>{coowner_stats.absents} copropriétaires absents</span>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <div
        style={{
          marginTop: '16px',
          padding: '12px 16px',
          border: '1px solid #e0e0e0',
          borderRadius: '4px',
          backgroundColor: '#fafafa',
        }}
      >
        <span>
          {tantiemesVotants} tantièmes ({tantiemesVotantsPercent}%) votants
        </span>
        <span style={{ marginLeft: '24px' }}>
          {coownersVotants} copropriétaires ({coownersVotantsPercent}%) votants
        </span>
      </div>
    </>
  )
}

export const AG2 = (props) => {
  const [registrationModalOpen, setRegistrationModalOpen] = useState(false)

  return (
    <div>
      <Show {...props} title=" " actions={<EmptyShowActions />}>
        <TabsComponent idx={3} {...props} />
      </Show>
      <Show {...props} actions={false}>
        <SimpleShowLayout style={{ padding: '1rem' }}>
          <PresenceChart />
          <ButtonM
            onClick={() => {
              setRegistrationModalOpen(true)
            }}
            variant={'contained'}
            color={'secondary'}
            size={'medium'}
            disableElevation
          >
            Enregistrer des Copropriétaires
          </ButtonM>
          <RegistrationModal
            onClose={() => {
              setRegistrationModalOpen(false)
            }}
            open={registrationModalOpen}
          />

          <Title5 />
          <ArrayField
            label="Enregistrements Copropriétaires"
            source="ag_registrations"
          >
            <Datagrid bulkActionButtons={false}>
              <TextField label="Copropriétaire" source="libelle" />
              <TextField label="VPC" source="vpc" />
              <TextField label="Représenté par" source="representant" />
              <FunctionField
                label="Nombre de tantièmes (en %)"
                source="percentage_tantiemes"
                render={(record) => `${record.total_percentage_tantiemes}%`}
              />
              <TextField source="token" label="Code authentification directe" />
              <BooleanField source="validated" label="Validé?" />
              <ShowRegistration {...props} />
              <DeleteButton />
              <ValidateButton />
              <DisplayVPCLink />
            </Datagrid>
          </ArrayField>
          <ArrayField label="Représentants" source="mandatories">
            <Datagrid bulkActionButtons={false}>
              <TextField source="mandatory" label="Représentant" />
              <FunctionField
                label="Nombre de tantièmes cumulés (en %)"
                source="total_percentage_tantiemes"
                render={(record) => `${record.total_percentage_tantiemes}%`}
              />
              <TextField
                source="total_coowner_mandate"
                label="Nombre de personnes représentées(copropriétaire inclus)"
              />
            </Datagrid>
          </ArrayField>
          <ArrayField source="coproprietaires_absents">
            <Datagrid bulkActionButtons={false}>
              <TextField source="libelle" />
            </Datagrid>
          </ArrayField>
          <ArrayField
            label="Copropriétaires enregistrés n'ayant pas voté sur la résolution courante"
            source="coproprietaires_novote"
          >
            <Datagrid bulkActionButtons={false}>
              <TextField source="id" />
              <TextField source="phone" />
              <TextField source="token" label="Code authentification directe" />
              <TextField label="Copropriétaire" source="libelle" />
            </Datagrid>
          </ArrayField>
        </SimpleShowLayout>
      </Show>
    </div>
  )
}

import { styled } from '@mui/material/styles'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import { HtmlTooltip } from '../components/html_tooltip'
import { Resolutions } from '../components/Resolutions'
import { useFormContext } from 'react-hook-form'
import Convocations from '../components/Convocations'
import OpposantsDefaillants from '../components/OpposantsDefaillants'
import config from '../config'
import DateTimePickerWithTimezone from '../intranet/AGS/AgsAdmin/components/DateTimePickerWithTimezone'
import ConfigVisio from '../intranet/AGS/AgsInfos/components/ConfigVisio/ConfigVisio'
import { backofficeRequest } from '../axios'
import { Bar } from 'react-chartjs-2'
import { RegistrationModal } from './components/RegistrationModal'

const truncate = (text, limit = 100) => {
  if (text.length > limit) {
    return text.substring(0, 100) + '...'
  }
  return text
}

export const AG3_refactored = (props) => {
  return (
    <div>
      <Show {...props} actions={false} title=" " resource="ags3">
        <TabsComponent idx={4} {...props} />
      </Show>

      <Show {...props} actions={false} title=" " resource="ags3">
        <SimpleShowLayout style={{ padding: '1rem' }}>
          <Resolutions />
        </SimpleShowLayout>
      </Show>
    </div>
  )
}
export const AG_Convocation = (props) => {
  return (
    <div>
      <Show {...props} actions={false} title=" " resource="ags3">
        <TabsComponent idx={1} {...props} />
      </Show>

      <Show {...props} actions={false} title=" " resource="ags3">
        <SimpleShowLayout style={{ padding: '1rem' }}>
          <Convocations />
        </SimpleShowLayout>
      </Show>
    </div>
  )
}

const SyncCopromaticSection = () => {
  const record = useRecordContext()
  const notify = useNotify()
  const translate = useTranslate()
  const [disabled, setDisabled] = useState(false)

  return (
    <Grid>
      <Typography variant="h6">
        {translate('hs.copromatic.ag.sync_section_title')}
      </Typography>
      <br />
      <Button
        color="secondary"
        variant="contained"
        label="hs.copromatic.ag.send_text"
        disabled={disabled}
        onClick={() => {
          setDisabled(true)
          sendDataToCopromatic(record.id)
            .then(async (response) => {
              let body = await response.json()

              if (300 <= response.status) {
                if (body && body.message)
                  body.message.forEach((message) => {
                    notify(
                      translate('hs.copromatic.ag.errors.send', { message }),
                      'error'
                    )
                  })
                else
                  notify(
                    translate('hs.copromatic.ag.errors.send', {
                      message: "Erreur d'envoi",
                    }),
                    'error'
                  )
              } else
                notify(translate('hs.copromatic.ag.success_send', 'success'))
            })
            .catch((e) => {
              console.log(e)
              if (504 === e.status)
                notify(
                  translate('hs.copromatic.ag.errors.server_timeout'),
                  'info'
                )

              notify(
                translate('hs.copromatic.ag.errors.send', {
                  message: e.message,
                }),
                'error'
              )
            })
            .finally(() => {
              setDisabled(false)
            })
        }}
      />
    </Grid>
  )
}

export const AG4 = (props) => {
  return (
    <div>
      <Show {...props} title=" " actions={null}>
        <TabsComponent idx={5} {...props} />
      </Show>
      <Show {...props} actions={false}>
        <SimpleShowLayout style={{ padding: '1rem' }}>
          <SignPvAndAttendanceTitle />
          <SendPvAg />
        </SimpleShowLayout>
      </Show>
      <Show {...props} actions={false} title=" ">
        <SimpleShowLayout style={{ padding: '1rem' }}>
          <OpposantsDefaillants />
        </SimpleShowLayout>
      </Show>
      <Show {...props} title=" " actions={null}>
        <SimpleShowLayout style={{ padding: '1rem' }}>
          <Title7 />
          <ContractButton />
          <SendContractAg />
        </SimpleShowLayout>
      </Show>
      <Show {...props} title=" " actions={null}>
        <SimpleShowLayout style={{ padding: '1rem' }}>
          <Typography variant="h6">Admin</Typography>
          <AG6 />
        </SimpleShowLayout>
      </Show>
    </div>
  )
}

export const AG5 = (props) => {
  return (
    <div>
      <Show {...props} actions={<EmptyShowActions />}>
        <TabsComponent idx={2} {...props} />
      </Show>
      <Show {...props} actions={false}>
        <RegisterPapier />
      </Show>
    </div>
  )
}

/**
 * This function calls the copromatic sync endpoint.
 *
 * @param {Number} ag_copromatic_id The copromatic id
 *
 * @return void
 */
const sendDataToCopromatic = (ag_copromatic_id) => {
  const request = new Request(`${config.API_V1}/sync_copromatic/send_ag`, {
    method: 'PUT',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ ag_copromatic_id: ag_copromatic_id }),
    json: true,
  })

  return fetch(request)
}

export const AG6 = (props) => {
  const refresh = useRefresh()
  const [loading, setLoading] = useState(false)
  const notify = useNotify()
  const transformData = (formData) => {
    return {
      documentsCheckCompleted: formData.check_doc_ok,
      pvCheckCompleted: formData.check_pv_ok,
      opsCheckCompleted: formData.check_ops_ok,
      financeCheckCompleted: formData.check_finance_ok,
      appealsCheckCompleted: formData.check_recours_ok,
      contractSigned: formData.contract_signed,
      heldAt: formData.datereelle,
      scheduledAt: formData.dateprevisionnelle,
      endDateTime: formData.end_datetime,
      pvFontSize: formData.pv_font_size,
    }
  }

  const onSubmit = async (formData) => {
    const coproId = formData.copro_internal_id
    const agId = formData.internal_id
    const payload = transformData(formData)

    try {
      setLoading(true)
      await backofficeRequest.put(
        `backoffice/condominiums/${coproId}/general-assemblies/${agId}/administration`,
        payload
      )
      notify('Enregistrement mis à jour avec succès', { type: 'success' })
      refresh()
    } catch (error) {
      notify(error?.response?.data?.message, { type: 'warning' })
    } finally {
      setLoading(false)
    }
  }
  return (
    <div>
      <Edit
        {...props}
        resource="ags6"
        mutationMode="pessimistic"
        actions={false}
        redirect={false}
        sx={{
          '& .MuiPaper-root': {
            boxShadow: 'none',
            border: 'none',
          },
        }}
        mutationOptions={{
          onSuccess: () => {
            refresh()
          },
        }}
      >
        <SimpleForm
          toolbar={<AdminToolbar loading={loading} />}
          variant="outlined"
          redirect={false}
          onSubmit={onSubmit}
        >
          <BooleanInput source="check_doc_ok" label="Doc signés" />
          <BooleanInput source="check_pv_ok" label="PV envoyés" />
          <BooleanInput source="check_ops_ok" label="Check ops" />
          <BooleanInput source="check_finance_ok" label="Check finance" />
          <BooleanInput source="check_recours_ok" label="Recours" />
          <BooleanInput
            source="contract_signed"
            label="hs.ags.contract_signed"
          />
          <DateTimePickerWithTimezone
            source="datereelle"
            label="Date reelle"
            sx={{ marginY: '20px' }}
          />
          <DateTimePickerWithTimezone
            source="dateprevisionnelle"
            label="Date previsionnelle"
            sx={{ marginY: '20px' }}
          />
          <DateTimePickerWithTimezone
            source={'end_datetime'}
            label={'AG terminée le'}
            sx={{ marginY: '20px' }}
          />
          <NumberInput
            source="pv_font_size"
            label="Taille de la police du PV"
            sx={{ marginY: '20px' }}
          />
          <SyncCopromaticSection {...props} />
        </SimpleForm>
      </Edit>
    </div>
  )
}

const AdminToolbar = ({ loading }) => {
  return (
    <Toolbar>
      <SaveButton disabled={loading} label={'Enregistrer'} type="submit" />
    </Toolbar>
  )
}
